import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const spinnerSizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
  xl: 'h-12 w-12 border-4',
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const { t } = useTranslation()
  
  return (
    <div
      className={cn(
        'animate-spin rounded-full border-brand-500 border-t-transparent',
        spinnerSizes[size],
        className
      )}
      role="status"
      aria-label={t('components.loading_spinner.loading')}
    >
      <span className="sr-only">{t('components.loading_spinner.loading')}</span>
    </div>
  )
}

export default LoadingSpinner
